module.exports = __webpack_public_path__ + "img/paysmart.7df1110f.png";